import axios from 'axios'

export const getDataAPI = async (url, token) => {
    const res = await axios.get(`https://joblibrary-api.onrender.com/api/${url}`, {
        headers: { Authorization: token }
    })
    console.log(res)
    return res;
}

export const postDataAPI = async (url, post, token) => {
    const res = await axios.post(`https://joblibrary-api.onrender.com/api/${url}`, post, {
        headers: { Authorization: token }
    })
    return res;
}


export const getDataJob = async (url, post) => {
    const res = await axios.post(`https://joblibrary-api.onrender.com/api/${url}`, post)
    return res;
}

export const putDataAPI = async (url, post, token) => {
    const res = await axios.put(`https://joblibrary-api.onrender.com/api/${url}`, post, {
        headers: { Authorization: token }
    })
    return res;
}

export const patchDataAPI = async (url, post, token) => {
    const res = await axios.patch(`https://joblibrary-api.onrender.com/api/${url}`, post, {
        headers: { Authorization: token }
    })
    return res;
}

export const deleteDataAPI = async (url, token) => {
    const res = await axios.delete(`https://joblibrary-api.onrender.com/api/${url}`, {
        headers: { Authorization: token }
    })
    return res;
}